import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { isDesktop } from "react-device-detect";

class JoinUs extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
    return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const { t } = this.props;

    const global = this.imageImport(
      require.context(
          "../../assets/images/",
          false,
          /\.(png|jpe?g|svg|webp)$/
      )
    );
    return (
      isDesktop ? (
      <div className='join-us'>
          <div className='x-container'>
              <div className='row'>
                  <div className='position-relative col'>
                      <img className='asset-1' src={global['club.svg']} alt='club'/>
                      <img className='asset-2' src={global['dice.svg']} alt='dice'/>
                      <img className='main-asset' src={global['brand-ambassador.webp']} alt='brand ambassador'/>
                  </div>

                  <div className='col d-flex flex-column align-items-start justify-content-center px-5'>
                      <h2>{t('global.join-xingbo')},</h2>
                      <h2>{t('global.waiting-for')}</h2>
                      <h1>{t('global.we-promise')}</h1>
                      <button className='btn btn-blue mt-4'>{t('page-header.join-now')}</button>                            
                  </div>
              </div>
          </div>
      </div>
      ) : (
        <div className='join-us'>
          <div className='d-flex flex-column align-items-center text-center justify-content-center m-container'>
            <h2>{t('global.join-xingbo')},</h2>
            <h2>{t('global.waiting-for')}</h2>
            <h1>{t('global.we-promise')}</h1>
            <button className='btn btn-blue my-4'>{t('page-header.join-now')}</button>                            
            <img className='main-asset' src={global['brand-ambassador.webp']} alt='brand ambassador'/>  
          </div>
        </div>
      )
    );
  }
}

export default withNamespaces("translation")(JoinUs);
